function setLocalizations() {
  const localizationForms = document.querySelectorAll("div.localization-form")
  if (localizationForms.length) {
    localizationForms.forEach((item) => {
      item.querySelectorAll("li a").forEach((anchor) => {
        anchor.addEventListener("click", (event) => {
          event.preventDefault()
          item.querySelector(".disclosure + input[type='hidden']").value = event.currentTarget.dataset.value
          item.querySelector("form").submit()
        });
      });
    });
  }
}
setLocalizations();